import React from 'react';
import Card from '../../ui/Card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Line, ComposedChart } from 'recharts';
const CustomerBarChart: React.FC = () => {
  const data = [{
    customer: 'Maruti Suzuki',
    revenue: 1710,
    margin: 15.2
  }, {
    customer: 'Hyundai',
    revenue: 1425,
    margin: 14.8
  }, {
    customer: 'Tata Motors',
    revenue: 1280,
    margin: 13.5
  }, {
    customer: 'Mahindra',
    revenue: 980,
    margin: 14.1
  }, {
    customer: 'Honda',
    revenue: 850,
    margin: 15.8
  }, {
    customer: 'Toyota',
    revenue: 720,
    margin: 16.2
  }, {
    customer: 'Kia',
    revenue: 650,
    margin: 14.5
  }, {
    customer: 'VW Group',
    revenue: 580,
    margin: 13.8
  }, {
    customer: 'Renault-Nissan',
    revenue: 520,
    margin: 12.9
  }, {
    customer: 'MG Motor',
    revenue: 435,
    margin: 13.2
  }];
  return <Card className="p-6" data-id="element-8302">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8303">
        Top 10 OEM Customers - Revenue & Margin
      </h3>
      <ResponsiveContainer width="100%" height={300} data-id="element-8304">
        <ComposedChart data={data} layout="vertical" data-id="element-8305">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-8306" />
          <XAxis type="number" tick={{
          fontSize: 11
        }} data-id="element-8307" />
          <YAxis dataKey="customer" type="category" width={100} tick={{
          fontSize: 11
        }} data-id="element-8308" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} data-id="element-8309" />
          <Legend data-id="element-8310" />
          <Bar dataKey="revenue" fill="#3b82f6" name="Revenue (₹ Cr)" data-id="element-8311" />
          <Line dataKey="margin" stroke="#10b981" strokeWidth={2} name="Margin %" dot={{
          r: 4
        }} data-id="element-8312" />
        </ComposedChart>
      </ResponsiveContainer>
    </Card>;
};
export default CustomerBarChart;